import * as React from 'react';
import Left from '../../atoms/Icons/Left/Left.js';
import Right from '../../atoms/Icons/Right/Right.js';
import * as Typography from '../../atoms/Typography/Typography.js';
import { CarouselContainer, CarouselHeader, Menu, ArrowButton, CarouselRow, CarouselItem } from './Carousel.styles.js';

// Accessibility Guidelines: https://www.w3.org/WAI/ARIA/apg/patterns/carousel/
var Carousel = function (_a) {
    var children = _a.children, title = _a.title;
    var carouselRowRef = React.useRef();
    var carouselItemRefArray = React.useRef(children.map(function () { return React.createRef(); }));
    var scrollToBeginning = function () {
        carouselRowRef.current.scrollLeft = 0;
    };
    var scrollToEnd = function () {
        carouselRowRef.current.scrollLeft = carouselRowRef.current.scrollWidth;
    };
    var scrollLeft = function () {
        var row = carouselRowRef.current;
        // https://app.excalidraw.com/s/4YGZLoMXzaS/6EJK52jwwhO
        var startingScrollPosition = row.scrollLeft;
        var amountToScroll = row.clientWidth;
        var childWidth = carouselItemRefArray.current[0].current.offsetWidth;
        var approximateNewScrollLeft = startingScrollPosition - amountToScroll + childWidth / 2; // x - y + (z / 2)
        var newScrollLeft = 0;
        carouselItemRefArray.current.some(function (child) {
            if (child.current.offsetLeft < approximateNewScrollLeft) {
                newScrollLeft = child.current.offsetLeft;
                return false;
            }
            return true;
        });
        row.scrollLeft = newScrollLeft;
    };
    var scrollRight = function () {
        var row = carouselRowRef.current;
        var startingScrollPosition = row.scrollLeft;
        var amountToScroll = row.clientWidth;
        var childWidth = carouselItemRefArray.current[0].current.offsetWidth;
        var approximateNewScrollLeft = startingScrollPosition + amountToScroll - childWidth / 2;
        var newScrollLeft = 0;
        carouselItemRefArray.current.some(function (child) {
            if (child.current.offsetLeft >= approximateNewScrollLeft) {
                newScrollLeft = child.current.offsetLeft;
                return true;
            }
            return false;
        });
        row.scrollLeft = newScrollLeft;
    };
    var arrowLeftOnClick = function () {
        var row = carouselRowRef.current;
        if (!row)
            return;
        if (row.scrollLeft === 0) {
            scrollToEnd();
        }
        else {
            scrollLeft();
        }
    };
    var arrowRightOnClick = function () {
        var row = carouselRowRef.current;
        if (!row)
            return;
        var hasFullyScrolled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 1;
        if (hasFullyScrolled) {
            scrollToBeginning();
        }
        else {
            scrollRight();
        }
    };
    return (React.createElement(CarouselContainer, { "data-testid": "Carousel", "aria-label": title },
        React.createElement(CarouselHeader, null,
            React.createElement(Typography.Heading, { as: "h3" }, title),
            React.createElement(Menu, { type: "toolbar" },
                React.createElement(ArrowButton, { type: "button", "aria-label": "Scroll Left", onClick: arrowLeftOnClick },
                    React.createElement(Left, null)),
                React.createElement(ArrowButton, { type: "button", "aria-label": "Scroll Right", onClick: arrowRightOnClick },
                    React.createElement(Right, null)))),
        React.createElement(CarouselRow, { ref: carouselRowRef }, children.map(function (child, index, arr) {
            var focussableElements = ["button", "input", "select", "textarea"];
            var focussable = focussableElements.includes(child.type) ||
                "tabindex" in child.props ||
                "href" in child.props;
            var tabIndex;
            if (!focussable) {
                tabIndex = 0;
            }
            return (React.createElement(CarouselItem, { "aria-label": "".concat(index + 1, " of ").concat(arr.length), key: "carousel-item-".concat(index), 
                // need ref to calculate new scroll positioning
                ref: carouselItemRefArray.current[index], "data-testid": "Carousel-Item-".concat(index), tabIndex: tabIndex }, child));
        }))));
};

export { Carousel as default };
//# sourceMappingURL=Carousel.js.map
